'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Clock, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const tabs = [
  { label: 'Home', href: '/', icon: Home },
  { label: 'History', href: '/customer-history', icon: Clock },
  { label: 'Profile', href: '/customer-profile', icon: User },
];

export default function CustomerBottomNav() {
  const pathname = usePathname();

  return (
    <nav className="bottom-nav">
      {tabs?.map((tab) => {
        const isActive = tab?.href === '/' ? pathname === '/' : pathname?.startsWith(tab?.href);
        const Icon = tab?.icon;
        return (
          <Link
            key={`customer-tab-${tab?.label}`}
            href={tab?.href}
            className="nav-tab"
            style={{ textDecoration: 'none' }}
          >
            <Icon
              size={22}
              strokeWidth={isActive ? 2.2 : 1.8}
              color={isActive ? '#1C1C1E' : '#8E6B7A'}
            />
            <span
              className={isActive ? 'tab-active' : 'tab-inactive'}
              style={{ fontSize: '11px' }}
            >
              {tab?.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}